import { rules, type schema } from "@/utils/validators";
import type { userFormData } from "./types.props";

export const userSchema = (isEditMode: boolean): schema<userFormData> => ({
    identifier: [rules.required("El identificador es requerido.")],
    first_name: [rules.required("El primer nombre es requerido.")],
    last_name: [rules.required("El primer apellido es requerido.")],
    email: [
        rules.required("El correo es requerido."),
        rules.isEmail("El formato del correo no es válido."),
    ],
    password: isEditMode
        ? [
            rules.minLength(
                8,
                "La contraseña debe tener al menos 8 caracteres si se modifica.",
            ),
            rules.isStrongPassword(),
        ]
        : [
            rules.required("La contraseña es requerida."),
            rules.minLength(8, "La contraseña debe tener al menos 8 caracteres."),
            rules.isStrongPassword(),
        ],
    role: [rules.required("El rol es requerido.")],
    status: [rules.required("El estado es requerido.")],
    institution: [
        (value, data) => {
            if (data?.role !== "Facilitador" && !value) {
                return "La institución es requerida para este rol.";
            }
            return null;
        },
    ],
});
